import { IDangKyChuyenNganhActionTypes } from "../../action-types/dang-ky-chuyen-nganh/IDangKyChuyenNganhActions";
import { IDangKyChuyenNganhReducer } from "../../reducer-model/dang-ky-chuyen-nganh/IDangKyChuyenNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initState: IDangKyChuyenNganhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dots: [],
  currentDotId: 0,
  currentTab: "dot-dang-ky",
  thietLapStatus: eReducerStatusBase.is_not_initialization,
  thietLaps: [],
  sinhVienStatus: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  ketQuaStatus: eReducerStatusBase.is_not_initialization,
  ketQuas: [],
  isXetTuDongRunning: false,
};

export const dangKyChuyenNganhReducer = (
  state: IDangKyChuyenNganhReducer = initState,
  action: IDangKyChuyenNganhActionTypes
): IDangKyChuyenNganhReducer => {
  switch (action.type) {
    case "DANG_KY_CHUYEN_NGANH_LOAD_DOTS_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "DANG_KY_CHUYEN_NGANH_LOAD_DOTS_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, dots: action.payload };
    case "DANG_KY_CHUYEN_NGANH_LOAD_DOTS_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, dotEditing: action.payload };
    case "DANG_KY_CHUYEN_NGANH_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };

    case "DANG_KY_CHUYEN_NGANH_SAVE_DOT_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "DANG_KY_CHUYEN_NGANH_SAVE_DOT_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "DANG_KY_CHUYEN_NGANH_SAVE_DOT_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_DELETE_DOT_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "DANG_KY_CHUYEN_NGANH_DELETE_DOT_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "DANG_KY_CHUYEN_NGANH_DELETE_DOT_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_CHANGE_CURRENT_DOT":
      return {
        ...state,
        currentDotId: action.payload,
        thietLapStatus: eReducerStatusBase.is_not_initialization,
        thietLaps: [],
        sinhVienStatus: eReducerStatusBase.is_not_initialization,
        sinhViens: [],
        ketQuaStatus: eReducerStatusBase.is_not_initialization,
        ketQuas: [],
      };
    case "DANG_KY_CHUYEN_NGANH_CHANGE_CURRENT_TAB":
      return { ...state, currentTab: action.payload };

    case "DANG_KY_CHUYEN_NGANH_LOAD_THIET_LAPS_START":
      return { ...state, thietLapStatus: eReducerStatusBase.is_loading };
    case "DANG_KY_CHUYEN_NGANH_LOAD_THIET_LAPS_SUCCESS":
      return {
        ...state,
        thietLapStatus: eReducerStatusBase.is_completed,
        thietLaps: action.payload,
      };
    case "DANG_KY_CHUYEN_NGANH_LOAD_THIET_LAPS_ERRR":
      return { ...state, thietLapStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_SUBMIT_THIET_LAPS_START":
      return { ...state, thietLapStatus: eReducerStatusBase.is_saving };
    case "DANG_KY_CHUYEN_NGANH_SUBMIT_THIET_LAPS_SUCCESS":
      return { ...state, thietLapStatus: eReducerStatusBase.is_need_reload };
    case "DANG_KY_CHUYEN_NGANH_SUBMIT_THIET_LAPS_ERRR":
      return { ...state, thietLapStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_LOAD_SINH_VIENS_START":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_loading };
    case "DANG_KY_CHUYEN_NGANH_LOAD_SINH_VIENS_SUCCESS":
      return {
        ...state,
        sinhVienStatus: eReducerStatusBase.is_completed,
        sinhViens: action.payload,
      };
    case "DANG_KY_CHUYEN_NGANH_LOAD_SINH_VIENS_ERRR":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_SUBMIT_NGUYEN_VONG_START":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_saving };
    case "DANG_KY_CHUYEN_NGANH_SUBMIT_NGUYEN_VONG_SUCCESS":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_need_reload };
    case "DANG_KY_CHUYEN_NGANH_SUBMIT_NGUYEN_VONG_ERRR":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_DELETE_KET_QUA_DANG_KY_START":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_deleting };
    case "DANG_KY_CHUYEN_NGANH_DELETE_KET_QUA_DANG_KY_SUCCESS":
      return {
        ...state,
        sinhVienStatus: eReducerStatusBase.is_need_reload,
        ketQuaStatus: eReducerStatusBase.is_need_reload,
      };
    case "DANG_KY_CHUYEN_NGANH_DELETE_KET_QUA_DANG_KY_ERRR":
      return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_LOAD_KET_QUAS_START":
      return { ...state, ketQuaStatus: eReducerStatusBase.is_loading };
    case "DANG_KY_CHUYEN_NGANH_LOAD_KET_QUAS_SUCCESS":
      return {
        ...state,
        ketQuaStatus: eReducerStatusBase.is_completed,
        ketQuas: action.payload,
      };
    case "DANG_KY_CHUYEN_NGANH_LOAD_KET_QUAS_ERRR":
      return { ...state, ketQuaStatus: eReducerStatusBase.is_completed };

    case "DANG_KY_CHUYEN_NGANH_XET_TU_DONG_START":
      return { ...state, isXetTuDongRunning: true };
    case "DANG_KY_CHUYEN_NGANH_XET_TU_DONG_SUCCESS":
      return {
        ...state,
        isXetTuDongRunning: false,
        ketQuaStatus: eReducerStatusBase.is_need_reload,
      };
    case "DANG_KY_CHUYEN_NGANH_XET_TU_DONG_ERRR":
      return { ...state, isXetTuDongRunning: false };

    default:
      return state;
  }
};
